/* The one way a vessel's size is written — "110 × 11.4 m, 1.6 m draft" — so
   the fleet list, the detail page and anything later never disagree on it. */
import type { Vessel } from '@/lib/types'

export function vesselDimensions(v: Pick<Vessel, 'length_m' | 'width_m' | 'draft_m'>): string {
  return `${v.length_m} × ${v.width_m} m, ${v.draft_m} m draft`
}
